import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.function.bind";
import _get from "lodash/get";
import _isNil from "lodash/isNil";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import analytics from '@nerdwallet/analytics';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { CheckboxOption } from '@nerdwallet/react-checkbox';
import cloneDeep from 'lodash/cloneDeep';
import * as actions from '../../redux/actions';
var InteractionLocation = 'compare-card-checkbox';
/**
 * KetoCompareCardCheckBox
 * checkbox component(desktop and mobile) to be used for the Keto cards
 *
 * @component
 * @example
 * <KetoCompareCardCheckBox
 *    card: {},
 *    compareCards: {
 *      cardIDsToCompare: [],
 *    }
 *  />
 */

export var KetoCompareCardCheckBox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(KetoCompareCardCheckBox, _React$Component);

  var _super = _createSuper2(KetoCompareCardCheckBox);

  /*
  * Used to set default values for the props argument
  * @defaultProps
  */

  /*
  * @constructor
  */
  function KetoCompareCardCheckBox(props) {
    var _this;

    _classCallCheck(this, KetoCompareCardCheckBox);

    _this = _super.call(this, props);
    _this.handleCompareCardChange = _this.handleCompareCardChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
  * Onchange handler for the keto-checkbox if not passed in by the consumer
  * as a handleCompare prop.
  * @param {object} e  emitted event object
  * @param {unknown} addCardOverride
  *
  * @return {undefined}
  */


  _createClass(KetoCompareCardCheckBox, [{
    key: "handleCompareCardChange",
    value: function handleCompareCardChange(e, addCardOverride) {
      // if the event checked is true, invoke saveToCompare to add the card in the compare bar
      // to make the card available for comparison. If the event checked is false,
      // remove it from the compare bar
      if (e && e.target.checked || addCardOverride) {
        // Set a flag denoting we need to fetch more compare data
        var cardToAdd = cloneDeep(this.props.card);
        cardToAdd.fetchCompareData = true;
        this.props.saveToCompare({
          cards: [cardToAdd],
          productLocation: InteractionLocation
        });
      } else {
        this.props.removeFromCompare(this.props.card.id, InteractionLocation);
      }
    }
    /*
    * Render the component
    */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleCompare = _this$props.handleCompare,
          showCheckboxLabel = _this$props.showCheckboxLabel,
          checkboxLabel = _this$props.checkboxLabel,
          isSelectedToCompare = _this$props.isSelectedToCompare,
          compareCards = _this$props.compareCards,
          card = _this$props.card; // get all the added cardIds from the compare bar

      var cardIDsToCompare = (compareCards === null || compareCards === void 0 ? void 0 : compareCards.cardIDsToCompare) || []; // if the boolean isSelectedToCompare is defined (true/false)
      // we will use the value, if not we will check cardIDsToCompare
      // the current card id already added in the
      // cardIDsToCompare; then display the checkbox checked=true

      var isInCompare = !_isNil(isSelectedToCompare) ? isSelectedToCompare : cardIDsToCompare.indexOf(_get(card, 'id', null)) > -1; // use handleCompareCardChange for onChange if the consumer did not pass the handleCompare prop

      var onChange = handleCompare || this.handleCompareCardChange; // if the uncheckedText or checkedText is undefined or an empty string
      // then use the default value else use the value passed in by the consumer

      var uncheckedText = checkboxLabel && checkboxLabel.uncheckedText || "Add to compare";
      var checkedText = checkboxLabel && checkboxLabel.checkedText || "Added to compare"; // if showCheckboxLabel=true, display the checkbox label, as per checked={true/false}
      // else display empty string

      var label = "";
      if (showCheckboxLabel) label = isInCompare ? checkedText : uncheckedText; // isInCompare param accounts for the handleCompareClick function to
      // decide whether to call the saveToCompare or removeFromCompare

      var clickHandler = function clickHandler(impressionId) {
        var _this2$props$analytic;

        if (((_this2$props$analytic = _this2.props.analytics) === null || _this2$props$analytic === void 0 ? void 0 : _this2$props$analytic.enabled) || _this2.props.enableAnalytics) {
          var elementInteractedPayload = {
            entity_name: "product_card_compare",
            action: isInCompare ? 'unselect' : 'select',
            interaction_type: 'press'
          };

          if (impressionId) {
            elementInteractedPayload.impression_id = impressionId;
          }

          analytics.track('element_interacted', elementInteractedPayload);
        }

        onChange(null, !isInCompare, card === null || card === void 0 ? void 0 : card.offerId);
      };

      return React.createElement(ImpressionContext.Consumer, null, function (value) {
        return React.createElement("div", {
          className: "keto-compare-checkbox"
        }, React.createElement(CheckboxOption, {
          className: "input",
          label: label,
          checked: isInCompare,
          onChange: function onChange() {
            return clickHandler(value === null || value === void 0 ? void 0 : value.impressionId);
          },
          inline: true
        }));
      });
    }
  }]);

  return KetoCompareCardCheckBox;
}(React.Component);
/**
 * The mapStateToProps function to use for the connected component
 */

_defineProperty(KetoCompareCardCheckBox, "propTypes", {
  /*
  * Card object containing the card id rendering the checkbox
  */
  card: PropTypes.shape({
    /*
    * Legacy ID
    */
    id: PropTypes.number,

    /*
    * Offer ID
    */
    offerId: PropTypes.string
  }).isRequired,

  /*
  *  **DEPRECATED**: Whether we want to send bedrock analytics events
  */
  enableAnalytics: PropTypes.bool,

  /*
  * Whether we want to send bedrock analytics events
  */
  analytics: PropTypes.shape({
    enabled: PropTypes.bool
  }),

  /*
  * Onchange handler for the checkbox
  */
  handleCompare: PropTypes.func,

  /*
  * Function to invoke when the checkbox is checked to add the card in the compare bar
  */
  saveToCompare: PropTypes.func.isRequired,

  /*
  * Function to invoke when the checkbox is unchecked to remove the card from the compare bar
  */
  removeFromCompare: PropTypes.func.isRequired,

  /*
  * Checkbox label
  */
  checkboxLabel: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /*
  * Display Checkbox label, {true when in desktop/false when in mobile}
  */
  showCheckboxLabel: PropTypes.bool,

  /*
  * Determine if checkbox is selected to compare
  */
  isSelectedToCompare: PropTypes.bool,

  /*
  * All cards in compare bar
  */
  compareCards: PropTypes.shape({
    cardIDsToCompare: PropTypes.array
  })
});

_defineProperty(KetoCompareCardCheckBox, "defaultProps", {
  analytics: {
    enabled: false
  },
  checkboxLabel: {
    uncheckedText: "Add to Compare",
    checkedText: "Added to Compare"
  },
  enableAnalytics: false,
  showCheckboxLabel: true
});

export var mapStateToProps = function mapStateToProps(_ref) {
  var compareCards = _ref.compareCards;
  return {
    compareCards: compareCards
  };
};
/**
 * The mapDispatchToProps function dispatching actions to the store.
 */

var mapDispatchToProps = {
  saveToCompare: actions.saveToCompare,
  removeFromCompare: actions.removeFromCompare
};
export default connect(mapStateToProps, mapDispatchToProps)(KetoCompareCardCheckBox);
//# sourceMappingURL=keto-compare-card-checkbox.js.map